import { FEATURE_NAME } from './consts';

export const RESET_PASSWORD = `${FEATURE_NAME}/RESET_PASSWORD`;

export const UPDATE_PERSONNEL = `${FEATURE_NAME}/UPDATE_PERSONNEL`;
